export function clamp(min: number, input: number, max: number) {
  return Math.max(min, Math.min(input, max));
}

export function mapRange(in_min: number, in_max: number, input: number, out_min: number, out_max: number) {
  if (in_min === in_max) {
    return out_min; // Return out_min as a fallback to avoid division by zero.
  }
  return ((input - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}

export function vwMinMax(value: number, min: number = 0, max: number = 100) {
  // Use a dynamic scaling based on the logarithm of the value (for example)
  const scaleFactor = Math.log(value);
  // Adjust the scale to map it between min and max
  const vw = max - ((scaleFactor - Math.log(1000)) / (Math.log(5000) - Math.log(1000))) * (max - min);
  // Return the result as a string with 'vw'
  return vw.toFixed(2) + 'vw';
}

export const getRange = (value: number, total: number): number => {
  if (value > total) {
    return 0;
  }
  if (value <= 0) {
    return 100;
  }
  // Calculate the value and ensure it's within 0-100 range
  const result = Math.round(100 - (value / total) * 100);

  // Clamp the result between 0 and 100
  return Math.max(0, Math.min(result, 100));
};

export const clampvw = (minPx: number, maxPx: number, minViewport = 375, maxViewport = 1920): string => {
  const vw = (((maxPx - minPx) / (maxViewport - minViewport)) * 100).toFixed(3);
  return `clamp(${minPx}px,${vw}vw,${maxPx}px)`;
};
